import { ChartLine, DashboardState, PartnerSummaryState } from './store'
import { RequestState } from '../../types'

export const LOAD_PARTNER_SUMMARY_REQUEST = 'LOAD_PARTNER_SUMMARY_REQUEST'
export const LOAD_PARTNER_SUMMARY_RECEIVED = 'LOAD_PARTNER_SUMMARY_RECEIVED'
export const LOAD_PARTNER_SUMMARY_ERROR = 'LOAD_PARTNER_SUMMARY_ERROR'
export const SUBSCRIPTION_CHART_REQUEST = 'SUBSCRIPTION_CHART_REQUEST'
export const SUBSCRIPTION_CHART_RECEIVED = 'SUBSCRIPTION_CHART_RECEIVED'
export const SUBSCRIPTION_CHART_ERROR = 'SUBSCRIPTION_CHART_ERROR'

export type DashboardAction =
  | { type: typeof LOAD_PARTNER_SUMMARY_REQUEST, partnerId: string }
  | { type: typeof LOAD_PARTNER_SUMMARY_RECEIVED, partnerId: string, summary: PartnerSummaryState }
  | { type: typeof LOAD_PARTNER_SUMMARY_ERROR, partnerId: string, error: Error }
  | { type: typeof SUBSCRIPTION_CHART_REQUEST }
  | { type: typeof SUBSCRIPTION_CHART_RECEIVED, data: ChartLine[] }
  | { type: typeof SUBSCRIPTION_CHART_ERROR }

export function dashboardReducer(state: DashboardState, action: DashboardAction) {
  switch (action.type) {
    case LOAD_PARTNER_SUMMARY_REQUEST: {
      return {
        ...state,
        partnerSummary: {
          ...state.partnerSummary,
          requestState: RequestState.Loading
        }
      }
    }

    case LOAD_PARTNER_SUMMARY_RECEIVED: {
      return {
        ...state,
        partnerSummary: action.summary
      }
    }

    case LOAD_PARTNER_SUMMARY_ERROR: {
      return {
        ...state,
        partnerSummary: {
          ...state.partnerSummary,
          requestState: RequestState.Error
        }
      }
    }

    case SUBSCRIPTION_CHART_REQUEST: {
      return {
        ...state,
        subscriptionChartData: {
          data: undefined,
          requestState: RequestState.Loading
        }
      }
    }

    case SUBSCRIPTION_CHART_RECEIVED: {
      return {
        ...state,
        subscriptionChartData: {
          data: action.data,
          requestState: RequestState.Loaded
        }
      }
    }

    case SUBSCRIPTION_CHART_ERROR: {
      return {
        ...state,
        subscriptionChartData: {
          data: undefined,
          requestState: RequestState.Error
        }
      }
    }

    default: {
      return state
    }
  }
}
